<template>
    <v-dialog
        :value="isOpen"
        max-width="800px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 v-if="currentStep === 1" class="text-subtitle-1">
                    Produkty opóźnione na dzień {{ dateFormattedDot }}: <strong>{{ partner }}</strong>
                </h1>
                <h1 v-if="currentStep === 2" class="text-subtitle-1">
                    Zamówienia opóźnione na dzień {{ dateFormattedDot }}: <strong>{{ partner }} / {{ product }}</strong>
                </h1>
            </v-card-title>
            
            <v-window v-model="currentStep">
                <v-window-item :value="1">
                    <v-data-table
                        :headers="productsHeaders"
                        :items="ordersProductsDelayed"
                        :mobile-breakpoint="0"
                        name="reportsData"
                    >
                        <template #item.prodName="{item}">
                            {{ item.prodName }}
                        </template>
                        <template #item.toSend="{item}">
                            {{ item.toSend }}
                        </template>
                        <template #item.quantity="{item}">
                            {{ formatNumber(item.quantity) }}
                        </template>
                        <template #item.details="{item}">
                            <v-tooltip :open-delay="tooltipDelay" top>
                                <template #activator="{on}">
                                    <v-btn 
                                        icon
                                        data-sentry-label="Wyświetl szczegóły"
                                        v-on="on"
                                        @click="getOrderList(item)"
                                    >
                                        <v-icon color="blue">
                                            mdi-ballot
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Wyświetl szczegóły</span>
                            </v-tooltip>
                        </template>
                        <template slot="no-results" :value="true">
                            <p class="text-center">
                                Brak danych
                            </p>
                        </template>
                    </v-data-table>
                    <v-card-actions>
                        <v-btn
                            color="error"
                            text
                            data-sentry-label="Zamknij"
                            @click="onClose"
                        >
                            Zamknij
                        </v-btn>
                    </v-card-actions>
                </v-window-item>
                
                <v-window-item :value="2">
                    <v-card-actions>
                        <v-btn
                            text
                            color="primary"
                            class="pa-0 ml-2"
                            @click="currentStep--"
                        >
                            <v-icon color="primary">
                                mdi-arrow-left
                            </v-icon>
                            powrót do produktów
                        </v-btn>
                    </v-card-actions>
                    <v-data-table
                        :headers="ordersHeaders"
                        :items="ordersList"
                        :mobile-breakpoint="0"
                        sort-by="sendDate"
                        :sort-asc="true"
                        :items-per-page="5"
                        name="reportsData"
                    >
                        <template #item.sendDate="{item}">
                            {{ formatDate(item.sendDate, false) }}
                        </template>
                        <template #item.quantity="{item}">
                            {{ formatNumber(item.quantity) }}
                        </template>                        
                        <template slot="no-results" :value="true">
                            <p class="text-center">
                                Brak danych
                            </p>
                        </template>
                    </v-data-table>
                    <v-card-actions>
                        <v-btn
                            color="error"
                            text
                            data-sentry-label="Zamknij"
                            @click="onClose"
                        >
                            Zamknij
                        </v-btn>
                    </v-card-actions>
                </v-window-item>
            </v-window>
        </v-card>
    </v-dialog>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'
import pagination from '@/mixins/dataTablePagination'
import tooltipDelay from '@/mixins/tooltip'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'OrdersProductsDelayedListDialog',
    mixins: [
        pagination,
        dateFormatter,
        tooltipDelay,
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        partner: {
            type: String,
            default: ''
        },
        ordersProductsDelayed: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            productsHeaders: [
                {
                    text: 'Produkt',
                    value: 'prodName',
                    sortable: false,
                    width: 400,
                },
                {
                    text: 'Do wysyłki',
                    value: 'toSend',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Nakład',
                    value: 'quantity',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Szczegóły',
                    value: 'details',
                    sortable: false,
                    align: 'center'
                }
            ],
            ordersHeaders: [
                {
                    text: 'Zamówienie',
                    value: 'orderNumber',
                    sortable: false,
                },
                {
                    text: 'Nr klienta',
                    value: 'customerNumber',
                    sortable: false,
                },
                {
                    text: 'Nakład',
                    value: 'quantity',
                    sortable: false,
                },
                {
                    text: 'Realizacja',
                    value: 'sendDate',
                    sortable: false,
                },
            ],
            ordersList: [],
            product: '',
            currentStep: 1
        }
    },
    
    computed: {
        dateFormattedDot() {
            return this.formatDate(new Date(), false)
        },
    },
    methods: {
        formatNumber(number) {
            return new Intl.NumberFormat('pl-PL').format(number)
        },
        getOrderList(product) {
            this.$store.dispatch('dashboard/getOrdersProductsDelayedByOrder', {
                query: `?partner=${product.partner}&productId=${product.productId}`
            })
                .then(response => {
                    this.ordersList = response.data.results
                    this.product = product.prodName
                    this.currentStep = 2
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        onClose() {
            setTimeout(() => {
                this.currentStep = 1
                this.product = ''
                this.ordersList = []
            }, 500)

            this.$emit('close-delayed-orders-products-dialog')
        }
    }
}
</script>